import Marquee from "react-fast-marquee";
import { STATS } from "../../data";

export const StatsMarquee = () => {
  return (
    <section data-testid="stats-marquee" className="relative border-y border-hairline bg-surface/40 py-8">
      <Marquee speed={38} gradient gradientColor="#030303" gradientWidth={120} autoFill>
        {STATS.map((s, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-4xl text-parchment px-10">{s}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
